import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { Caption } from '@src/elements/typography/typography'

import './input-footnote.sass'

@Component
export class InputFootnote extends Vue {

  render (h: CreateElement) {
    return <Caption class='input-footnote'>
      <div>{this.$slots.default}</div>
    </Caption>
  }
}
